import React from "react";
import { Link } from "react-router-dom";
import "./bannerthree.css";
import Banner1 from "../../../src/assets/images/banner-1.png";
import Banner2 from "../../../src/assets/images/banner-2.png";
import Banner3 from "../../../src/assets/images/banner-3.png";
import EastIcon from '@mui/icons-material/East';

function BannerThree(){
    return(
        <>
           <div className="container-fluid mb_15">
            <div className="row">
                <div className="col-md-4">
                    <div className="relative  sm_mb_15">
                        <div className="bannerImg">
                            <img src={Banner1} alt="" className="img-fluid radius_box_8" />
                        </div>
                        <div className="banner_text">
                            <h5>Everyday Fresh &
                                Clean with Our
                                Products
                                </h5>
                                <Link to="searchproductlist" className="shop_now_btn"> Shop Now <EastIcon /></Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                <div className="relative sm_mb_15">
                        <div className="bannerImg">
                            <img src={Banner2} alt="" className="img-fluid radius_box_8" />
                        </div>
                        <div className="banner_text">
                            <h5>Make your Breakfast
                            Healthy and Easy
                                </h5>
                                <Link to="searchproductlist" className="shop_now_btn"> Shop Now <EastIcon /></Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                <div className="relative">
                        <div className="bannerImg">
                            <img src={Banner3} alt="" className="img-fluid radius_box_8" />
                        </div>
                        <div className="banner_text">
                            <h5>The best Organic
                                 Products Online
                                </h5>
                                <Link to="searchproductlist" className="shop_now_btn"> Shop Now <EastIcon /></Link>
                        </div>
                    </div>
                </div>
            </div> 
            </div>

        </>
    )
}

export default BannerThree;